import { styled } from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileSignature,
  faGalaxy,
  faKipSign,
  faMoon,
  faSolarSystem,
  faSunBright,
  faUserAstronaut
} from "@fortawesome/pro-light-svg-icons";
import { useState } from "react";
import { useClickAway } from "@uidotdev/usehooks";
import Typograpy from "./common/Typography";
import AgentDetail from "./agents/AgentDetail";
import Window from "./common/Window";
import { transition } from "../styles/mixins";
import { formatNumber } from "../utils/helpers";

const Root = styled.div`
  align-items: center;
  border-bottom: var(--border);
  display: flex;
  flex: 1 0 auto;
  height: var(--space-10);
  justify-content: space-between;
  padding-inline: var(--space-6);
  text-transform: capitalize;
`;

const Menu = styled.div`
  display: flex;
  height: 100%;

  > * + * {
    border-left: var(--border);
  }
`;

const MenuItem = styled.div`
  align-items: center;
  background-color: ${props => props.$isOpen ? 'var(--border-color)' : 'transparent'};
  display: flex;
  gap: var(--space-2);
  padding-inline: var(--space-3);
  position: relative;
  cursor: pointer;


  &:hover {
    background-color: var(--color-theme-primary-300);
  }
`;

const AgentWindow = styled(Window)`
  ${transition('opacity, scale')}
  opacity: ${props => props.$isOpen ? '1' : '0'};
  pointer-events: ${props => props.$isOpen ? 'all' : 'none'};
  position: absolute;
  right: 0;
  scale: ${props => props.$isOpen ? '1' : '0.75'};
  top: var(--space-12);
  transform-origin: top right;
  width: 256px;
  z-index: 2;

  &::before {
    aspect-ratio: 1;
    background-color: var(--color-theme-primary);
    border-left: var(--border-width) var(--border-style) var(--window-border);
    border-top: var(--border-width) var(--border-style) var(--window-border);
    content: '';
    position: absolute;
    right: var(--space-4);
    rotate: 45deg;
    top: 0;
    translate: -50% -50%;
    width: var(--space-3);
  }
`;

function Header({ store }) {
  const agent = store.state.agent;
  const [isOpen, setOpen] = useState(false);
  const ref = useClickAway(() => {
    setOpen(false);
  });

  const toggleDarkmodeHandle = () => {
    if (store.state.darkmode) {
      store.setDarkmode(false);
    } else {
      store.setDarkmode(true);
    }
  }

  return (
    <Root>
      <Typograpy fontSize="lg" as="h1">Galaxia Haven 3000</Typograpy>
      <Menu>
        <MenuItem onClick={() => store.setModal('systems')}><FontAwesomeIcon size="lg" icon={faSolarSystem} /> Current solar system</MenuItem>
        <MenuItem onClick={() => store.setModal('systems')}><FontAwesomeIcon size="lg" icon={faGalaxy} /> Solar systems</MenuItem>
        <MenuItem onClick={() => store.setModal('contracts')}><FontAwesomeIcon size="lg" icon={faFileSignature} /> Contract</MenuItem>
      </Menu>
      <Menu>
        <MenuItem><FontAwesomeIcon icon={faKipSign} /> {formatNumber(store.state.agent.credits)}</MenuItem>
        <MenuItem onClick={() => toggleDarkmodeHandle()}>
          <FontAwesomeIcon size="lg" icon={store.state.darkmode ? faSunBright : faMoon} />
        </MenuItem>
        <MenuItem $isOpen={isOpen} onClick={() => setOpen(true)}>
          <FontAwesomeIcon size="lg" icon={faUserAstronaut} />
          <p>{agent.symbol}</p>
          <AgentWindow ref={ref} $padding $isOpen={isOpen} children={<AgentDetail store={store} />} />
        </MenuItem>
      </Menu>
    </Root>
  )
}

export default Header;
